import React from 'react';
import MuiAlert, { AlertProps as MuiAlertProps } from '@mui/material/Alert';

/**
 * Pioneer Alert — wraps MUI Alert with project defaults.
 *
 * Defaults:
 * - variant="outlined" (Pioneer standard)
 *
 * When variant="filled" is used, we explicitly force
 * `color: 'common.white'` via the sx prop so that Tailwind Preflight's
 * `color: inherit` reset cannot clobber MUI's contrast text.
 *
 * All MUI Alert props are supported and can override defaults.
 */
export interface AlertProps extends MuiAlertProps {}

const Alert = React.forwardRef<React.ComponentRef<typeof MuiAlert>, AlertProps>(
  function Alert({ sx, ...rest }, ref) {
    const filledSx =
      rest.variant === 'filled'
        ? { color: 'common.white', '& .MuiAlert-icon': { color: 'common.white' }, ...sx }
        : sx;
    return <MuiAlert variant="outlined" ref={ref} sx={filledSx} {...rest} />;
  },
);

export default Alert;
